<template>
  <div class="side-wrapper">
    <div class="nav-wrapper" v-for="(item, index) in navList" :key="index">
      <div class="title">{{ item.title }}</div>
      <div class="col-list">
        <div
          :class="{ 'col-item': true, active: v.link == $route.path }"
          @click="routeTo(v.link)"
          v-for="(v, index) in item.colList"
          :key="index"
        >
          {{$t(v.title)}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    };
  },
  methods: {
    routeTo(link) {
      this.$router.push(link);
    },
    async getUserInfo() {
      const params = { member: localStorage.getItem("userID") };
      const { data } = await this.$post("GetUserInfo", params);
      if(data.State) {
        if(data.ReturnJson2 != 1 && data.ReturnJson2 != 2) {
          let hide = document.getElementsByClassName('nav-wrapper')[2]
          hide.style.display = 'none'
        }
      }
    }
  },
  created() {
    this.getUserInfo()
  },
  computed:{
    navList(){
      return[
        {
          title:this.$t('jyzx'),
          colList: [
            { text: "管理首页",title:"Side.ManagementHomepage", link: "/manageHome" },
            { text: "预报包裹",title:"Side.Forecastpackage", link: "/newBag" },
            { text: "我的包裹",title:"Side.Mypackage", link: "/myBag" },
            { text: "我的订单",title:"Side.Myorder", link: "/myOrder" },
            { text: "订单跟踪",title:"Side.ddgz", link: "/ordertracking" },
            // { text: "自提点查询",title:"Side.ztdcx", link: "/pick" },
            // { text: "国内订单跟踪",title:"Side.Domesticordertracking", link: "/domesticexpresstracking" },
			      { text: "快遞100",title:"kd100", link: "/domesticexpresstracking" },
            { text: "拒收包裹",title:"jsbg", link: "/rejectPackage" },
            // { text: "同行订单导入", link: "/orderimport" },
            // { text: "单个订单详细", link: "/detailedorder" },
          ],
        },
        {
          title: this.$t('Side.Usercenter'),
          colList: [
            { text: "个人信息管理",title:"Side.Personal",link: "/personalCenter" },
            { text: "优惠券", title:"Side.coupon",link: "/volume" },
            { text: "消费流水",title:"Side.Consumptionflow", link: "/consumptionflow" },
            { text: "银行转账", title:"Side.banktransfer",link: "/banktransfer" },
            { text: "推荐奖励ex",title:"Side.Recommended", link: "/integralcenter" },
            { text: "收货地址管理",title:"Side.Receiving", link: "/shippindaddress" }
          ],
        },
        {
          title: this.$t('Side.PromotionCenter'),
          colList: [
            { text: "推广链接", title:"Side.Promotionlink",link: "/promotionlink" },
            { text: "我的推荐", title:"Side.Myrecommendation",link: "/myrecommendation" },
            { text: "我的收益", title:"Side.Myearnings",link: "/myearnings" },
          ],
        },
        {
          title: this.$t('Side.Memberservices'),
          colList: [
            // { text: "联系方式", link: "/contact" },
            { text: "系统公告", title:"Side.answer",link: "/answer" },
            { text: "新手引导", title:"Side.Noviceguidance",link: "/noviceguidance" },
          ],
        },
      ]
    }
  },
};
</script>
<style lang="scss" scoped>
.side-wrapper {
   width: 116px;
  height: 750px;
  background: #fff;
  border-radius: 5px;
  // padding: 0px 20px 8px 22px;
  box-sizing: border-box;
  margin-right: 14px;
  text-align: center;
  .nav-wrapper {
    margin-bottom: 28px;
    .title {
      font-size: 16px;
      color: #fff;
      font-weight: 500;
      line-height: 1;
      background: #206BA4;
      line-height: 30px;
    }
    .col-list {
      .col-item {
        font-weight: 400;
        font-size: 12px;
        color: #666;
        margin-top: 16px;
        line-height: 1;
        cursor: pointer;
        &.active {
          @include color($_color);
        }
        &:hover {
          @include color($_color);
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/layout/side/index.vue